// Safari hack #478. Forces any tooltips to hide after you open a modal
import React from 'react'
import { Tooltip } from 'shared/ui'

const TooltipFix = ({
  isModalOpen,
  key,
  offsetX,
  tooltip,
  dispatch, // eslint-disable-line no-unused-vars
  ...rest
}) => {
  if (!isModalOpen) {
    return <Tooltip key={key} offsetX={offsetX} tooltip={tooltip} {...rest} />
  }
  return <div {...rest} />
}

export default TooltipFix
